import { createReducer } from 'redux-act';

import {
  SCREEN_GROUP_FETCH_DATA_INIT,
  SCREEN_GROUP_FETCH_DATA_SUCCESS,
  SCREEN_GROUP_FETCH_DATA_FAIL,
  SCREEN_GROUP_DELETE_CATEGORY_INIT,
  SCREEN_GROUP_DELETE_CATEGORY_SUCCESS,
  SCREEN_GROUP_DELETE_CATEGORY_FAIL,
  SCREEN_GROUP_CLEAR_DATA,
  SCREEN_GROUP_CREATE_CATEGORY_INIT,
  SCREEN_GROUP_CREATE_CATEGORY_SUCCESS,
  SCREEN_GROUP_CREATE_CATEGORY_FAIL,
  SCREEN_GROUP_MODIFY_CATEGORY_INIT,
  SCREEN_GROUP_MODIFY_CATEGORY_SUCCESS,
  SCREEN_GROUP_MODIFY_CATEGORY_FAIL,
  SCREEN_GROUP_CLEAN_UP,
  SCREEN_GROUP_CLEAR_DATA_LOGOUT,
  SET_SCREEN_GROUP,
} from 'state/actions/screenGroup';

const initialState = {
  list: [],
  screenGroup: {
    _id: '',
    name: '',
    description: '',
  },
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const screenGroupReducer = createReducer(
  {
    [SCREEN_GROUP_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [SCREEN_GROUP_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      screenGroup: payload.screenGroup || initialState.screenGroup,
      loading: false,
      error: null,
    }),
    [SCREEN_GROUP_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCREEN_GROUP_DELETE_CATEGORY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCREEN_GROUP_DELETE_CATEGORY_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: null,
      deleted: true,
    }),
    [SCREEN_GROUP_DELETE_CATEGORY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCREEN_GROUP_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [SCREEN_GROUP_CREATE_CATEGORY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCREEN_GROUP_CREATE_CATEGORY_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.concat(payload.screengroup),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [SCREEN_GROUP_CREATE_CATEGORY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCREEN_GROUP_MODIFY_CATEGORY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCREEN_GROUP_MODIFY_CATEGORY_SUCCESS]: (state, payload) => ({
      ...state,
      list: !state.list
        ? []
        : state.list.map((elem) => {
            if (elem._id === payload.id) {
              return {
                _id: payload.id,
                name: payload.screenGroup.name,
                description: payload.screenGroup.description,
                siteId: payload.screenGroup.siteId,
                modifiedAt: new Date().toDateString(),
                modifiedBy: payload.screenGroup.modifiedBy,
              };
            }
            return elem;
          }),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [SCREEN_GROUP_MODIFY_CATEGORY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCREEN_GROUP_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [SCREEN_GROUP_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [SET_SCREEN_GROUP]: (state, payload) => ({
      ...state,
      screenGroup: payload.data,
    }),
  },
  initialState
);
